import { hasRoundSummary, parseRoundSummary } from '../../shared/roundSummary';
import type { ScriptStatus } from '../../shared/types';

interface Props {
  roundSummary: string | null;
  status: ScriptStatus;
}

// Feature H — "what changed since your last visit". Shows the AI-generated
// bullets for the CURRENT round only (so a stale summary from an earlier round
// never lingers), and never once approved. Renders nothing when there's no
// usable summary — the page then looks exactly as it did before this feature.
//
// Client-review redesign (2026-07-18): lives in the hero's right side now, a
// compact card rather than a full-width banner — same gating/data logic
// above, only the presentation changed to fit its new home (per the
// mock-up's "not a banner" call).
export default function WhatChangedBanner({ roundSummary, status }: Props) {
  if (!hasRoundSummary(roundSummary, status)) return null;
  // hasRoundSummary already confirmed this parses to a usable summary.
  const summary = parseRoundSummary(roundSummary)!;

  return (
    <div
      data-print-hide
      className="w-full md:w-[320px] md:flex-none bg-accent/5 border border-line border-l-[3px] border-l-accent rounded-r-md px-3.5 py-3"
    >
      <span className="font-mono text-[10px] uppercase tracking-[0.12em] font-medium text-accent block mb-1.5">
        What changed
      </span>
      <ul className="space-y-1 list-disc pl-4">
        {summary.bullets.map((b, i) => (
          <li key={i} className="text-[13px] md:text-[12px] text-muted leading-snug">
            {b}
          </li>
        ))}
      </ul>
    </div>
  );
}
